module.exports = __webpack_public_path__ + "static/media/Safety_Goggles.2432fd0d.svg";